import styled from "styled-components";


export const FrequencyFilterContainer = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 16px;
   border-bottom: 1px solid rgba(118, 127, 141, 0.1);
`;

export const LeftFrequencyFilter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const LeftFrequencySelectFilter = styled.div`
    display: flex;
    gap: 12px;
`;

export const LeftFrequencyButtonFilter = styled.div`
    display: flex;
    gap: 8px;
`;

export const RightFrequencyFilter = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px 32px;
    margin-top: 12px;
`;

export const FrequencyDrawerRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-bottom: 1px solid rgba(48, 55, 66, 0.1);
    margin-bottom: 12px;
    padding-bottom: 12px;

    span{
        overflow: hidden;
        color: var(--Content-Neutral-High, #303742);
        text-overflow: ellipsis;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 145%; /* 21.75px */
        letter-spacing: -0.15px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        align-self: stretch;
    }

    p{
        color: var(--Content-Neutral, #767F8D);
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 145%; /* 18.85px */
        letter-spacing: -0.13px;
    }
`;

export const Au = styled.img`
  width: 91px;
  height: 96px;
`;

export const StringDesign = styled.div`
    span{
        overflow: hidden;
        color: var(--Content-Neutral-High, #303742);
        text-overflow: ellipsis;

        /* Body/Medium -> Regular */
        font-family: "Sharon Sans";
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 145%; /* 21.75px */
        letter-spacing: -0.15px;
    }
    p{
        overflow: hidden;
        color: var(--Content-Neutral, #767F8D);
        text-overflow: ellipsis;

        /* Body/Small -> Regular */
        font-family: "Sharon Sans";
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 145%; /* 18.85px */
        letter-spacing: -0.13px;
    }
`